import React from 'react'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

interface IProps {
    display?: any
    children?: any[] | any
    height?: number | string
    left?: string | number | undefined
    marginBottom?: string | number | undefined
    marginLeft?: string | number | undefined
    marginRight?: string | number | undefined
    marginTop?: string | number | undefined
    position?: "absolute" | undefined
    top?: string | number | undefined
}

export default function(props: IProps) {
    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                display: props.display,
                height: props.height,
                left: props.left,
                marginBottom: props.marginBottom,
                marginLeft: props.marginLeft,
                marginRight: props.marginRight,
                marginTop: props.marginTop,
                position: props.position,
                top: props.top,
            }
        }),
    );

    const classes = useStyles();

    return (
        <img src={props.children} className={classes.root} />
    )
}
